import React from "react";

import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import ContactForm from "../Components/Contact/ContactForm";

const ContactUsPage = () => (
  <>
    <Header />
    <ContactForm />
    <Footer />
  </>
);

export default ContactUsPage;
